import { useEffect, useMemo, useState } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';
import SearchInput from '../components/SearchInput';
import { auditAPI } from '../services/api';
import { filterBySearch } from '../utils/search';

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    auditAPI.list({ limit: 100 }).then(({ data }) => setLogs(data)).finally(() => setLoading(false));
  }, []);

  const filteredLogs = useMemo(
    () => filterBySearch(logs, search, [
      'user_name',
      'module',
      'action_type',
      'record_id',
      (log) => new Date(log.created_at).toLocaleString('en-IN'),
    ]),
    [logs, search]
  );

  if (loading) return <LoadingSpinner />;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Audit Log</h1>
        <p className="text-slate-500">M11 — immutable compliance trail (7-year retention)</p>
      </div>

      <SearchInput
        className="max-w-md"
        placeholder="Search by user, module, action…"
        value={search}
        onChange={setSearch}
      />

      <div className="card overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-slate-500 border-b text-left">
              <th className="pb-2">Time</th><th className="pb-2">User</th><th className="pb-2">Module</th>
              <th className="pb-2">Action</th><th className="pb-2">Record</th>
            </tr>
          </thead>
          <tbody>
            {filteredLogs.map((l) => (
              <tr key={l.id} className="border-b border-slate-100">
                <td className="py-2">{new Date(l.created_at).toLocaleString('en-IN')}</td>
                <td>{l.user_name || '—'}</td>
                <td>{l.module}</td>
                <td className="capitalize">{l.action_type}</td>
                <td>{l.record_id || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {logs.length > 0 && filteredLogs.length === 0 && (
          <p className="text-center py-8 text-slate-500">No audit entries match your search.</p>
        )}
      </div>
    </div>
  );
}
